import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon, StarIcon, QuoteIcon } from 'lucide-react';
const testimonials = [{
  name: 'Camila',
  age: '29 años',
  text: 'Compré otros packs antes y me pasó que en la compu se veían lindos, pero al imprimirlos eran una decepción. Este la calidad es realmente buena.'
}, {
  name: 'Florencia',
  age: '34 años',
  text: 'Lo que más me sorprendió fue cómo se ven las páginas impresas. Ya había comprado otros imprimibles y no tenían la misma calidad.'
}, {
  name: 'Valentina',
  age: '27 años',
  text: 'El diseño está muy bien hecho y al imprimir queda hermoso. Para mí eso hace toda la diferencia.'
}, {
  name: 'Mariana',
  age: '31 años',
  text: 'Compre el pack de 29mil. La verdad me sorprendió para bien.'
}, {
  name: 'Carolina',
  age: '38 años',
  text: 'He comprado otros imprimibles antes y muchas veces terminan siendo una desilusión. Este está muy bien. Son tantas hojas que no sé cuando voy a terminar de pintarlos.'
}];
const variants = {
  enter: (direction: number) => ({
    x: direction > 0 ? '100%' : '-100%',
    opacity: 0
  }),
  center: {
    zIndex: 1,
    x: 0,
    opacity: 1
  },
  exit: (direction: number) => ({
    zIndex: 0,
    x: direction < 0 ? '100%' : '-100%',
    opacity: 0
  })
};
export function TestimonialsSection() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [direction, setDirection] = useState(0);
  const nextTestimonial = () => {
    setDirection(1);
    setCurrentIndex(prev => prev === testimonials.length - 1 ? 0 : prev + 1);
  };
  const prevTestimonial = () => {
    setDirection(-1);
    setCurrentIndex(prev => prev === 0 ? testimonials.length - 1 : prev - 1);
  };
  const goToTestimonial = (index: number) => {
    setDirection(index > currentIndex ? 1 : -1);
    setCurrentIndex(index);
  };
  return <section className="py-10 md:py-14 px-4 bg-[#F5F0FF]" data-id="element-132">
      <div className="max-w-4xl mx-auto" data-id="element-133">
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="text-center mb-10" data-id="element-134">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#2D2D3F]" data-id="element-135">
            Lo que dicen quienes ya lo compraron
          </h2>
          
        </motion.div>

        <div className="relative max-w-2xl mx-auto" data-id="element-136">
          <div className="relative w-full h-[280px] sm:h-[240px] flex items-center justify-center overflow-hidden px-4 sm:px-12" data-id="element-137">
            <AnimatePresence initial={false} custom={direction} data-id="element-138">
              <motion.div key={currentIndex} custom={direction} variants={variants} initial="enter" animate="center" exit="exit" transition={{
              x: {
                type: 'spring',
                stiffness: 300,
                damping: 30
              },
              opacity: {
                duration: 0.2
              }
            }} className="absolute w-full px-4 sm:px-12" data-id="element-139">
                <div className="bg-white rounded-3xl p-6 sm:p-8 shadow-lg border border-gray-100 relative" data-id="element-140">
                  <QuoteIcon className="absolute top-4 right-6 w-8 h-8 text-[#F5F0FF]" data-id="element-141" />

                  <div className="flex space-x-1 mb-4" data-id="element-142">
                    {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 text-[#FFD166] fill-current" data-id="element-143" />)}
                  </div>

                  <p className="text-[#2D2D3F] text-base sm:text-lg font-medium italic mb-6 leading-relaxed" data-id="element-144">
                    "{testimonials[currentIndex].text}"
                  </p>

                  <div className="flex items-center" data-id="element-145">
                    <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#FF6B8A] to-[#9B8FE8] flex items-center justify-center text-white font-bold text-lg mr-3" data-id="element-146">
                      {testimonials[currentIndex].name.charAt(0)}
                    </div>
                    <div data-id="element-147">
                      <h4 className="font-bold text-[#2D2D3F]" data-id="element-148">
                        {testimonials[currentIndex].name}
                      </h4>
                      <p className="text-xs text-[#6B7280]" data-id="element-149">
                        {testimonials[currentIndex].age}
                      </p>
                    </div>
                  </div>
                </div>
              </motion.div>
            </AnimatePresence>
          </div>

          {/* Navigation Arrows */}
          <button onClick={prevTestimonial} className="absolute left-0 top-1/2 -translate-y-1/2 z-10 w-10 h-10 bg-white rounded-full shadow-md flex items-center justify-center text-[#2D2D3F] hover:text-[#FF6B8A] transition-colors focus:outline-none" aria-label="Testimonio anterior" data-id="element-150">
            <ChevronLeftIcon className="w-6 h-6" data-id="element-151" />
          </button>

          <button onClick={nextTestimonial} className="absolute right-0 top-1/2 -translate-y-1/2 z-10 w-10 h-10 bg-white rounded-full shadow-md flex items-center justify-center text-[#2D2D3F] hover:text-[#FF6B8A] transition-colors focus:outline-none" aria-label="Siguiente testimonio" data-id="element-152">
            <ChevronRightIcon className="w-6 h-6" data-id="element-153" />
          </button>

          {/* Dot Indicators */}
          <div className="flex justify-center items-center space-x-2 mt-6" data-id="element-154">
            {testimonials.map((_, index) => <button key={index} onClick={() => goToTestimonial(index)} className={`w-2.5 h-2.5 rounded-full transition-colors focus:outline-none ${index === currentIndex ? 'bg-[#FF6B8A]' : 'bg-gray-300 hover:bg-gray-400'}`} aria-label={`Ir al testimonio ${index + 1}`} data-id="element-155" />)}
          </div>
        </div>
      </div>
    </section>;
}